var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.contract.title))])
        ])
      ]),
      _vm._v(" "),
      _vm.contract.contractCheckFileList != null &&
      _vm.contract.contractCheckFileList.length > 0
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c("swb-save-file", {
                  ref: "swb_contract_file",
                  attrs: {
                    showDelete: false,
                    files: _vm.contract.contractCheckFileList
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.contract.contractCheckFileList != null &&
      _vm.contract.contractCheckFileList.length == 0
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c("swb-save-file", {
                  ref: "swb_contract_file",
                  attrs: {
                    showDelete: false,
                    files: _vm.contract.contractCheckFileList
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合同名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("验收附件")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("验收附件")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a233d72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a233d72","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/CheckContract.vue
// module id = 3256
// module chunks = 0